/**
 * Allow only https URLs on trusted WillPlay hosts, or same-origin relative upload paths.
 * @param {string|null|undefined} raw
 * @returns {string|null}
 */
export function toSafeMediaUrl(raw) {
  if (!raw || typeof raw !== "string") return null;

  const value = raw.trim();
  if (!value) return null;

  if (value.startsWith("//") || /^javascript:/i.test(value) || /^data:/i.test(value)) {
    return null;
  }

  try {
    const url = new URL(value, typeof window !== "undefined" ? window.location.origin : "https://willplay.in");
    if (url.protocol !== "https:" && url.protocol !== "http:") return null;

    const host = url.hostname.toLowerCase();
    const trustedHost =
      host === "willplay.in" ||
      host.endsWith(".willplay.in") ||
      host.endsWith(".azurewebsites.net") ||
      (typeof window !== "undefined" && host === window.location.hostname.toLowerCase());

    const path = url.pathname || "";
    const allowedPath =
      path.startsWith("/uploads/") || path.startsWith("/chat-images/");

    if (!trustedHost || !allowedPath) return null;

    return url.toString();
  } catch {
    return null;
  }
}
